function applyMeta(routes) {
  return routes.map((route) => ({
    ...route,
    meta: {
      ...(route.meta || {}),
      category: 'ecommerce',
    },
  }));
}

export default applyMeta([
  {
    path: '/Akko',
    name: 'Akko',
    component: () => import('../../components/Akko.vue'),
  },
  {
    path: '/Barkwave',
    name: 'Barkwave',
    component: () => import('../../components/Barkwave.vue'),
  },
  {
    path: '/Christiancafe',
    name: 'Christiancafe',
    component: () => import('../../components/Christiancafe.vue'),
  },
  {
    path: '/Dreamzy',
    name: 'Dreamzy',
    component: () => import('../../components/Dreamzy.vue'),
  },
  {
    path: '/Listicle',
    name: 'Listicle',
    component: () => import('../../components/Listicle.vue'),
    children: [
      {
        path: 'Datenschutz',
        name: 'Datenschutz',
        component: () => import('../../common/Datenschutz.vue'),
      },
      {
        path: 'Bedingungen',
        name: 'Bedingungen',
        component: () => import('../../common/Bedingungen.vue'),
      },
    ],
  },
  {
    path: '/Listicle2',
    name: 'Listicle2',
    component: () => import('../../components/Listicle2.vue'),
    children: [
      {
        path: 'Datenschutz',
        name: 'Datenschutz2',
        component: () => import('../../common/Datenschutz.vue'),
      },
      {
        path: 'Bedingungen',
        name: 'Bedingungen2',
        component: () => import('../../common/Bedingungen.vue'),
      },
    ],
  },
  {
    path: '/Listicle3',
    name: 'Listicle3',
    component: () => import('../../components/Listicle3.vue'),
    children: [
      {
        path: 'Datenschutz',
        name: 'Datenschutz',
        component: () => import('../../common/Datenschutz.vue'),
      },
      {
        path: 'Bedingungen',
        name: 'Bedingungen',
        component: () => import('../../common/Bedingungen.vue'),
      },
    ],
  },
  {
    path: '/LizBuys',
    name: 'LizBuys',
    component: () => import('../../components/LizBuys.vue'),
  },
  {
    path: '/Lulutx',
    name: 'Lulutx',
    component: () => import('../../components/Lulutx.vue'),
  },
  {
    path: '/Matsato',
    name: 'Matsato',
    component: () => import('../../components/Matsato.vue'),
  },
  {
    path: '/Moving',
    name: 'Moving',
    component: () => import('../../components/Moving.vue'),
  },
  {
    path: '/Nuubu1',
    name: 'Nuubu1',
    component: () => import('../../components/Nuubu1.vue'),
  },
  {
    path: '/Property1',
    name: 'Property1',
    component: () => import('../../components/Property1.vue'),
  },
  {
    path: '/RetroPocket',
    name: 'RetroPocket',
    component: () => import('../../components/RetroPocket.vue'),
  },
  {
    path: '/Ryoko1',
    name: 'Ryoko1',
    component: () => import('../../components/Ryoko1.vue'),
  },
  {
    path: '/Soulmatesequence',
    name: 'Soulmatesequence',
    component: () => import('../../components/Soulmatesequence.vue'),
  },
  {
    path: '/ShoulderHealth',
    name: 'ShoulderHealth',
    component: () => import('../../components/ShoulderHealth.vue'),
  },
  {
    path: '/Trends',
    name: 'Trends',
    component: () => import('../../components/Trends.vue'),
  },
  {
    path: '/derila',
    name: 'derila',
    component: () => import('../../components/derila.vue'),
  },
]);
